export enum ErrorCode {
  NoFile = 1,
  ReadFileError,
  SaveRequestError,
  CancelRequestError,
  GetRequestsError,
  IcamApiError,
  ApiError,
  RefreshTokenError,
  CsaSearchError,
  NoError,
  GetMessageError,
}

export interface IError {
  code: ErrorCode;
  message: string;
}
